import { CURRENCYCONFIG } from 'BreetHelpers';

import type { ICurrencyBalanceProps } from './helpers';

export const CurrencyBalance = ({ variant, balance, ...props }: ICurrencyBalanceProps) => (
	<svg
		width='409'
		height='78'
		viewBox='0 0 409 78'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
		{...props}
	>
		<g clipPath='url(#clip0_8835_34860)'>
			<rect
				width='409'
				height='78'
				rx='8'
				fill='#ECFCFF'
			/>
			{variant === 'USD' && (
				<g clipPath='url(#clip1_8835_34860)'>
					<path
						d='M323.576 61.003C350.118 76.3123 393.3 76.2291 420.036 60.8088C446.772 45.3885 446.939 20.4276 420.397 5.1182C393.855 -10.1912 350.673 -10.108 323.937 5.31234C297.201 20.7327 297.034 45.6936 323.576 61.003ZM334.309 9.69437C344.543 3.78695 358.05 0.542031 372.361 0.542031C386.672 0.542031 399.873 3.73148 409.941 9.5557C420.48 15.6295 426.277 23.9221 426.277 32.8526C426.277 41.783 420.369 50.242 409.664 56.4268C399.43 62.3342 385.923 65.5791 371.612 65.5791C357.301 65.5791 344.1 62.3897 334.032 56.5655C323.493 50.4916 317.696 42.1991 317.696 33.2686C317.696 24.3381 323.604 15.8791 334.309 9.69437ZM335.446 54.1803C355.498 65.7455 388.114 65.6901 408.277 54.0416C428.468 42.3932 428.578 23.5616 408.554 11.9963C388.53 0.431094 355.887 0.486565 335.724 12.1627C315.561 23.8389 315.394 42.5873 335.446 54.1803ZM348.01 16.3229L354.001 19.7897C357.911 18.0979 362.016 17.3491 366.259 17.5432C370.503 17.7373 374.385 18.8467 377.935 20.8991L368.45 26.3627C366.509 25.2534 364.651 24.6155 362.876 24.4491C361.101 24.2827 359.492 24.5877 358.133 25.392C356.913 26.1131 356.33 26.8897 356.414 27.7217C356.497 28.5537 357.218 29.3858 358.577 30.1623C359.964 30.9666 361.434 31.3549 363.042 31.3827C364.651 31.4104 366.675 31.1053 369.144 30.5229C371.612 29.9405 374.025 29.4412 376.355 28.9975C378.684 28.5538 380.903 28.3041 383.039 28.2487C385.174 28.1932 387.199 28.3596 389.196 28.7479C391.165 29.1639 393.078 29.885 394.964 30.9666C398.154 32.7971 399.707 34.8772 399.679 37.2069C399.651 39.5366 398.071 41.8108 394.909 44.0295L400.511 47.2467L396.046 49.826L390.416 46.5811C385.923 48.6889 381.402 49.6873 376.854 49.6041C372.333 49.4932 368.145 48.3561 364.29 46.1373L373.748 40.6737C375.855 41.894 377.935 42.5596 379.988 42.6428C382.04 42.726 383.926 42.2823 385.673 41.2838C386.949 40.5627 387.559 39.7584 387.559 38.8987C387.559 38.0389 386.866 37.2346 385.562 36.4858C384.093 35.626 382.567 35.1823 381.014 35.1268C379.461 35.0713 377.381 35.3487 374.801 35.9866C372.222 36.6245 369.782 37.1514 367.48 37.6229C365.178 38.0666 362.959 38.344 360.823 38.3995C358.688 38.4549 356.691 38.2885 354.75 37.8725C352.808 37.4565 350.922 36.7077 349.064 35.626C345.93 33.8233 344.405 31.7155 344.516 29.3026C344.626 26.8897 346.263 24.56 349.48 22.3413L343.6 18.9577L348.01 16.3229ZM443 33.0745V55.1788C442.945 66.1338 435.484 76.4233 422.033 84.2166C408.582 91.9823 390.721 96.2811 371.751 96.3366C352.78 96.392 334.975 92.1487 321.607 84.4385C308.239 76.7006 300.945 66.4112 301 55.4838C301 55.3729 301 55.2897 301 55.1788V33.3518C301 44.8616 308.516 55.5393 322.189 63.4159C335.391 71.0428 352.891 75.2307 371.501 75.2307C390.111 75.2307 408.027 70.9596 421.451 63.2217C435.235 55.262 442.862 44.5565 443 33.0745Z'
						fill='#DCF3F7'
					/>
				</g>
			)}
			{variant === 'NGN' && (
				<g clipPath='url(#clip0_8836_35685)'>
					<rect
						width='409'
						height='78'
						rx='8'
						fill='#ECFCFF'
					/>
					<g clipPath='url(#clip1_8836_35685)'>
						<path
							d='M378.601 30.9562L371.362 29.8191L375.911 27.1843L380.487 29.8468L378.601 30.9562ZM370.087 35.8652L362.876 34.7281L361.905 35.2828L366.509 37.9453L370.087 35.8652ZM335.696 12.0968C355.887 0.448377 388.502 0.365176 408.526 11.9304C428.578 23.4956 428.44 42.3273 408.249 53.9757C388.059 65.6242 355.443 65.7074 335.419 54.1144C315.394 42.5769 315.533 23.7453 335.696 12.0968ZM335.807 31.2613L348.038 38.3335L342.796 41.3566L347.123 43.8527L352.364 40.8296L356.968 43.4921L351.726 46.5152L356.053 49.0113L361.295 45.9882L375.162 53.9757L384.703 48.4566L370.863 40.4691L376.937 36.9746L398.736 40.3859L408.249 34.8945L394.382 26.907L399.651 23.8562L395.325 21.3601L390.055 24.4109L385.479 21.7484L390.749 18.6976L386.422 16.2015L381.153 19.2523L368.922 12.18L359.409 17.6714L371.64 24.7437L364.623 28.7929L345.403 25.7699L335.807 31.2613ZM443 33.064C442.862 44.5738 435.235 55.2792 421.451 63.2113C408.027 70.9492 390.305 75.2203 371.501 75.2203C352.697 75.2203 335.391 71.0324 322.189 63.4054C308.516 55.5288 301 44.8511 301 33.3414V55.1683V55.4734C300.945 66.4285 308.239 76.6902 321.607 84.4003C334.975 92.1105 352.78 96.3261 371.751 96.2984C390.721 96.2706 408.582 91.9441 422.033 84.1785C435.484 76.4128 442.945 66.0956 443 55.1406V33.064ZM323.937 5.30189C350.673 -10.1462 393.855 -10.2294 420.397 5.10775C446.939 20.4171 446.772 45.3781 420.036 60.7984C393.3 76.2187 350.118 76.3296 323.576 60.9925C297.034 45.6554 297.201 20.7499 323.937 5.30189ZM317.696 33.2859C317.696 42.2164 323.493 50.5089 334.032 56.5828C344.1 62.3792 357.44 65.5964 371.612 65.5964C385.784 65.5964 399.43 62.3515 409.664 56.4441C420.369 50.2593 426.277 41.8835 426.277 32.8699C426.277 23.8562 420.48 15.6468 409.941 9.57299C399.873 3.7765 386.533 0.559318 372.361 0.559318C358.189 0.559318 344.543 3.80424 334.309 9.71166C323.604 15.8687 317.696 24.2445 317.696 33.2859Z'
							fill='#DCF3F7'
						/>
					</g>
				</g>
			)}
			{variant === 'GHS' && (
				<g clipPath='url(#clip0_8836_35118)'>
					<rect
						width='409'
						height='78'
						rx='8'
						fill='#ECFCFF'
					/>
					<path
						d='M336.5 69.8667V73.4167C332.358 69.275 328.808 63.95 325.85 58.625C329.4 62.7667 332.358 66.3167 336.5 69.8667Z'
						fill='#DCF3F7'
					/>
					<path
						d='M351.292 78.1493V83.4744C348.333 82.291 345.375 80.516 342.417 78.1493V73.416C345.375 75.7827 348.333 76.966 351.292 78.1493Z'
						fill='#DCF3F7'
					/>
					<path
						d='M401.583 74.0078V78.7411C398.625 80.5161 395.667 82.2911 392.708 84.0661V78.7411C395.667 76.9661 398.625 75.7828 401.583 74.0078Z'
						fill='#DCF3F7'
					/>
					<path
						d='M418.15 58.625C415.783 64.5417 412.233 69.275 407.5 73.4167V69.275C411.642 66.3167 415.192 62.7667 418.15 58.625Z'
						fill='#DCF3F7'
					/>
					<path
						d='M372 -24.209C344.192 -24.209 321.708 -1.72565 321.708 26.0827C321.708 53.891 344.192 76.3744 372 76.3744C399.809 76.3744 422.292 53.891 422.292 26.0827C422.292 -1.72565 399.809 -24.209 372 -24.209ZM372 64.541C350.7 64.541 333.542 47.3827 333.542 26.0827C333.542 4.78269 350.7 -12.3756 372 -12.3756C393.3 -12.3756 410.459 4.78269 410.459 26.0827C410.459 47.3827 393.3 64.541 372 64.541Z'
						fill='#DCF3F7'
					/>
					<path
						d='M387.975 13.066C389.158 14.2494 390.933 14.841 392.117 13.6577C393.3 12.4743 393.892 10.6993 392.708 9.51602C387.975 4.19102 382.058 0.641016 374.958 -0.542317V-3.50065C374.958 -5.27565 373.775 -6.45898 372 -6.45898C370.225 -6.45898 369.042 -5.27565 369.042 -3.50065V0.0493488C356.025 1.82435 345.375 12.4743 345.375 26.0827C345.375 39.691 356.025 50.9327 369.042 52.116V55.666C369.042 57.441 370.225 58.6244 372 58.6244C373.775 58.6244 374.958 57.441 374.958 55.666V52.7077C382.058 52.116 388.567 48.566 392.708 42.6494C393.892 41.466 393.3 39.691 392.117 38.5077C390.933 37.3244 389.158 37.916 387.975 39.0993C384.425 43.241 379.692 45.6077 374.958 46.791V5.96602C380.283 6.55768 385.017 8.92435 387.975 13.066ZM351.292 26.0827C351.292 15.4327 358.983 7.14935 369.042 5.96602V46.791C358.983 45.016 351.292 36.7327 351.292 26.0827Z'
						fill='#DCF3F7'
					/>
				</g>
			)}

			<text
				x='11'
				y='22'
				fill='#05A2BF'
				fontSize='12'
				fontFamily='Campton, sans-serif'
				fontWeight='400'
			>
				{variant === 'GHS' ? 'Cedis' : variant} Wallet Balance
			</text>
			<text
				x='11'
				y='66'
				fill='#05A2BF'
				fontSize='14'
				fontFamily='Campton-Medium, sans-serif'
				fontWeight='500'
			>
				{CURRENCYCONFIG[variant].symbol}
				{balance}
			</text>
		</g>
		<rect
			x='0.5'
			y='0.5'
			width='408'
			height='77'
			rx='7.5'
			stroke='#2FB1CA'
		/>

		<defs>
			<clipPath id='clip0_8835_34860'>
				<rect
					width='409'
					height='78'
					rx='8'
					fill='white'
				/>
			</clipPath>
			<clipPath id='clip1_8835_34860'>
				<rect
					width='142'
					height='142'
					fill='white'
					transform='translate(301 -26)'
				/>
			</clipPath>
		</defs>
	</svg>
);
